import React, { useState, useEffect, useContext } from 'react';
import PushNotificationDialog from './PushNotificationDialog';
import { UserContext } from '../User/UserContext';
import { requestNotificationPermission } from '../../utils/fcm-setup';
import { firebase } from '../../utils/firebase-config';

const PushNotificationPrompt = () => {
  const { userData } = useContext(UserContext);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    let cleanupEvents = () => {};

    // Check if user is logged in
    if (!userData) {
       return;
    }

    const init = async () => {
      // Check if messaging is supported safely, if not supported silently ignore
      try {
         const isSupported = await firebase.messaging.isSupported();
         if (!isSupported) {
             return;
         }
      } catch (err) {
         return;
      }

      // إذا كان الإذن ممنوحاً مسبقاً، أحاول إنشاء التوكن مرة واحدة بصمت
      if ('Notification' in window && Notification.permission === 'granted') {
         setTimeout(() => {
            requestNotificationPermission(userData.id);
         }, 1000);
         return; // نتوقف هنا لمنع الوصول لباقي الأكواد أدناه
      }

      if (!('Notification' in window)) {
         return;
      }

      // If denied, do nothing
      if ('Notification' in window && Notification.permission === 'denied') {
        return;
      }

      // Check if user previously cancelled during this session
      const hasCancelled = sessionStorage.getItem('pushPromptCancelled');
      if (hasCancelled) {
        return;
      }

      // التحقق مما إذا كان المستخدم يفتح التطبيق من خلال الـ PWA (التطبيق المُثبت) أو من ويندوز
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
      const isWindows = typeof navigator !== 'undefined' && /Windows/i.test(navigator.userAgent || '');

      // على ويندوز نسمح بطلب الإذن داخل المتصفح أيضاً، بينما يبقى PWA مدعوماً كما هو
      if (isStandalone || isWindows) {
        // في تطبيقات الـ PWA، نافذة النظام (مثل رسالة التصريح الخاصة بأندرويد 13+) تظهر بشكل أصلي كـ (Bottom Sheet)
        setTimeout(() => {
          requestNotificationPermission(userData.id);
        }, 1500); // تأخير بسيط لثانية ونصف بعد فتح التطبيق لتظهر النافذة بشكل لائق
      } else {
        // إذا كان يستخدم متصفح غير ويندوز وغير PWA، لا نطلب منه شيئاً
        console.log("يتم تجاهل طلب الإشعارات هنا، وسيُطلب فقط في PWA أو على ويندوز.");
      }
    };

    init();
  }, [userData]);

  // لم نعد بحاجة إلى إظهار الـ Dialog المخصص، سيرى المستخدم رسالة المتصفح الرسمية بدلاً من ذلك
  return null;
};

export default PushNotificationPrompt;
